"use client"

import { UserLock } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `UserLockIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const UserLockIcon = component(Icon)({ as: UserLock })
